import React, { Component } from 'react';
import { Container, Row, Col, Form } from 'react-bootstrap';
import RoleUtils from '../utils/roleUtils.js';
import CommonUtils from '../utils/siteUtils.js';
import ServiceCalls from '../utils/serviceCalls.js';
import { Loading } from '../components/Loading';
import { ConfirmModal } from '../components/ConfirmModal';
import '../styles/MaintainAccess.css';

export class SupplierTable extends Component {

    constructor(props) {
        super()
        this.handleClose = this.handleClose.bind(this);
        this.getSupplierInfo = this.getSupplierInfo.bind(this);
        this.updateSupplierInfo = this.updateSupplierInfo.bind(this);
        this.onActiveChange = this.onActiveChange.bind(this);
        this.state = {
            supplierInfo: '',
            statusChange: false,
            supplierStatus: false,
            isLoading: true,
        }
    }

    //Get supplier info and populate table on mount
    componentDidMount() {
        this.getSupplierInfo();
    }

    //Get supplier info and proper table when companyId changes
    componentDidUpdate(prevProps) {
        if (prevProps.currentCompanyId !== this.props.currentCompanyId) {
            this.getSupplierInfo();
           //DO WE NEED this.setState({ statusChange: false, isLoading: true })
        }
    }

    //Get supplier info for table
    getSupplierInfo() {
        const { currentCompanyId } = this.props;
        ServiceCalls.getSupplier(currentCompanyId).then(function (data) {
            if (data) {
                this.setState({ supplierInfo: data, supplierStatus: data.enabled, isLoading: false });
            }
            else {
                //Error need to handle
                console.log("No data returned from Service call");
                this.setState({ isLoading: false });
            }
        }.bind(this));    
    }

    //Update supplier status in DB based on dropdown change
    updateSupplierInfo() {
        const { currentCompanyId, onSupplierStatusUpdated } = this.props;
        onSupplierStatusUpdated(true);
        this.setState({ isLoading: true });
        ServiceCalls.updateSupplier(currentCompanyId, this.state.supplierStatus).then(function (data) {
            onSupplierStatusUpdated(false);
            if (data) {
                this.setState({ statusChange: false, supplierStatus: data.enabled, supplierInfo: data, isLoading: false });           
            }
            else {
                //update not successful. - need to handle
                console.log('Supplier Update not successful');
                this.setState({ isLoading: false, statusChange: false });
            }
        }.bind(this));
    }
    onActiveChange() {
        const { supplierStatus } = this.state;
        this.setState({           
            supplierStatus: !supplierStatus,
            statusChange: true 
        });
    }
    //Build proper status dropdown based on users role
    buildStatus() {
        const { currentUser, currentCompanyId } = this.props;
        var adminPerms = RoleUtils.optumAdminPerms();
        var canViewAdmin = RoleUtils.canAccess(currentUser, currentCompanyId, adminPerms);
      
            return (
                              
                <Form.Group as="div" className="supplierStatusCtrl"  controlId="supplierEnabled">                      
                        <Form.Switch
                            type="switch"
                            id="supplierStatus"
                            className="userStatusOption"
                            disabled={!canViewAdmin}
                            checked={this.state.supplierStatus}
                            onChange={this.onActiveChange}
                        />
                    </Form.Group>
               
            );
       
    }

    //Capture status dropdown and indicate that status has changed for modal
    //dropDownCapture(e) {
    //    this.setState({ statusCapture: e.target.value, statusChange: true });
    //}

    //Render proper status date - if no date in DB, return --
    renderStatusDate(updateDt) {
        //If null date in database, return --
        if (!updateDt) {
            return (
                <div>--</div>);
        }
        return (
            <div>{CommonUtils.formatDate(updateDt)}</div>
        );
    }

    //Handle close method for confirmModal
    handleClose() {
        const { supplierInfo } = this.state;
        this.setState({ supplierStatus: supplierInfo.enabled, statusChange: false});
    }

    buildTable() {
        const { supplierInfo } = this.state;
        return (supplierInfo) 
            ? <><Row className="access-headers">
                <Col sm={2}>
                    <h6 className="profileHdr">Supplier Set ID</h6>
                    <div>{supplierInfo.vendorSetId}</div>
                </Col>
        
                <Col sm={2}>
                    <h6 className="profileHdr">Supplier ID</h6>
                    <div>{supplierInfo.vendorId}</div>
                </Col>
                
                <Col sm={4}>
                    <h6 className="profileHdr">Supplier Name</h6>
                    <div>{supplierInfo.name}</div>
                </Col>
                <Col sm={2}>
                    <h6 className="profileHdr">Portal Access Status</h6>
                </Col>
                <Col sm={0}>
                    {/*{this.state.supplierStatus ? 'Active' : 'Inactive'}*/}
                    <div className="access-toolbar">{this.buildStatus()} </div>
                </Col>
                
                {/*<Col sm={5}>
                    <div className="access-supplier-spacing">{supplierInfo.vendorSetId}</div>
                    <div className="access-supplier-spacing">{supplierInfo.vendorId}</div>
                    <div>{supplierInfo.name}</div>
                </Col>*/}
                {/*<Col sm={3}>
                    <div>{supplierInfo.name}</div>
                </Col>*/}
             
                {/*<Col sm={1}>
                    <h6 className="profileHdr">Portal Access Status</h6>
                </Col>
                <Col sm={2}>    
                    {this.buildStatus()}
                </Col>*/}         
                {/*<Col sm={2}>
                    <h6 className="profileHdr">Status Date</h6>
                </Col>        
                <Col sm={2}>                  
                    {this.renderStatusDate(supplierInfo.updated_Dt)}
                </Col>*/}
                {/*<Col sm={1}>
                    
                </Col>*/}
              
            </Row>
                <Row className="access-headers">
                    <Col sm={{ span: 2,offset:8  }}>
                        <h6 className="profileHdr">Status Date</h6>
                    </Col>
                    <Col sm={2} className="profileHdrValue">
                        {this.renderStatusDate(supplierInfo.updated_Dt)}
                    </Col>

                </Row>            </>
            



            : <Col></Col>;
    }

    render() {
        const { supplierStatus , statusChange, isLoading} = this.state;
        //Message to be passed in as prop to confirm modal
        var curStatus = (supplierStatus === true) ? 'active' : 'inactive';
        var msg = `Are you sure you want to change this supplier's status to ${curStatus}?`;  
        var display = <></>;
       
        if (isLoading && statusChange) {
            display = <div style={{ margin: "auto", width: "200px" }}>
                Updating Supplier Status <br/> <Loading />
            </div>;
        }
        else if (!isLoading) {
            display =this.buildTable();
        }
        else {
            display = <div style={{ margin: "auto", width: "200px" }}>
                <Loading />
            </div>;
        }
    
        return (
            <>
            <Row>
                <Col><h3 className="access-headers">Portal Access - Supplier</h3></Col>
            </Row>
                <ConfirmModal message={msg} handleAccept={this.updateSupplierInfo} handleClose={this.handleClose} isOpen={(statusChange && !isLoading)} />
                <Container fluid className="searchInputAreas border-left-dark shadow borderCurve">
                    {display}                   
                </Container>
            </>
        )
    }
}